export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_jp-4a0760f36fed31a486ec8b8ffe541c4f.webp";